import { ChangeDetectionStrategy, Component } from '@angular/core';

/** "Thinking" indicator shown in place of the next question while a classifier turn runs (#13383). */
@Component({
  selector: 'app-hts-assistant-thinking',
  templateUrl: './hts-assistant-thinking.component.html',
  styleUrls: ['./hts-assistant-thinking.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HtsAssistantThinkingComponent {}
